import React from "react";
import '../style/Store.css';
import nykaa from '../assets/nykaa.png';
import airindia from '../assets/airindia.png';
import dell from '../assets/dell.png';
import ajio from '../assets/ajio.png';
import { Link } from "react-router-dom";

const trendingMerchants = [
  { name: "Nykaa", coupons: 5, offers: 5, logo: nykaa },
  { name: "Air India", coupons: 5, offers: 5, logo: airindia },
  { name: "Dell", coupons: 5, offers: 5, logo: dell },
  { name: "AJIO", coupons: 5, offers: 5, logo: ajio },
];

const allMerchants = [
  { name: "Amazon", coupons: 5 },
  { name: "Flipkart", coupons: 5 },
  { name: "Myntra", coupons: 5},
  { name: "Ajio", coupons: 5 },
  { name: "Snapdeal", coupons: 6 },
  { name: "Meesho", coupons: 7},
  { name: "Shoppers Stop", coupons: 6},
  { name: "Tata CLiQ", coupons: 8 },
  { name: "Decathlon", coupons: 9 },
  { name: "Urban Company", coupons: 4 },
  { name: "Zivame", coupons: 2 },
  { name: "Lenskart", coupons: 10 },
  { name: "Reliance Digital", coupons: 8 },
  { name: "Croma", coupons: 9 },
  { name: "Pepperfry", coupons: 4 },
  { name: "Urban Ladder", coupons: 3 },
  { name: "FirstCry", coupons: 2 },
  { name: "Dmart", coupons: 9},
  { name: "Blinkit", coupons: 12},
  { name: "Nature's Basket", coupons: 5 },
  { name: "Samsung", coupons: 5 },
  { name: "Apple", coupons: 14 },
  { name: "Dell", coupons: 5 },
  { name: "Lenovo", coupons: 7 },
  { name: "HP", coupons: 9 },
  { name: "boAt", coupons: 38 },
  { name: "OnePlus", coupons: 8 },
  { name: "Xiaomi", coupons: 6 },
  { name: "Realme", coupons: 5 },
  { name: "Google", coupons: 8 },
  { name: "Logitech", coupons: 2 },
  { name: "Microsoft", coupons: 10 },
  { name: "LG", coupons: 6 },
  { name: "Whirlpool", coupons:4 },
  { name: "Bosch", coupons: 1 },
  { name: "Swiggy", coupons: 14 },
  { name: "Zomato", coupons: 10 },
  { name: "Dominos", coupons: 5 },
  { name: "Pizza Hut", coupons: 14 },
  { name: "KFC", coupons: 9 },
  { name: "McDonald's", coupons: 19},
  { name: "Starbucks", coupons: 11},
  { name: "Burger King", coupons: 15 },
  { name: "Subway", coupons: 10 },
  { name: "BigBasket", coupons: 8},
  { name: "JioMart", coupons: 9},
  { name: "Licious", coupons: 5 },
  { name: "MakeMyTrip", coupons: 5 },
  { name: "Goibibo", coupons: "Varies" },
  { name: "Yatra", coupons: 4 },
  { name: "RedBus", coupons: 8 },
  { name: "Oyo Rooms", coupons: 10 },
  { name: "Booking.com", coupons: 14 },
  { name: "Cleartrip", coupons: 5},
  { name: "EaseMyTrip", coupons: 16 },
  { name: "Nykaa", coupons: 5 },
  { name: "Mamaearth", coupons: 17 },
  { name: "Sugar Cosmetics", coupons: 4 },
  { name: "Minimalist", coupons: 10 },
  { name: "The Body Shop", coupons: 11 },
  { name: "L'Oréal", coupons: 15 },
  { name: "Lakmé", coupons: 9 },
  { name: "Kama Ayurveda", coupons: 2 },
  { name: "Forest Essentials", coupons:4 },
  { name: "Bluestone", coupons: 5 },
  { name: "CaratLane", coupons: 10 },
  { name: "Melorra", coupons: 11 },
  { name: "Pharmeasy", coupons: 14 },
  { name: "Apollo Pharmacy", coupons: 17 },
  { name: "Netmeds", coupons: 9 },
  { name: "1mg", coupons: 5 },
  { name: "Medlife", coupons: 6},
  { name: "Healthkart", coupons: 7 },
  { name: "Netflix", coupons: 2 },
  { name: "Amazon", coupons: 5 },
  { name: "Hotstar", coupons: 11 },
  { name: "Spotify", coupons: 17 },
  { name: "Gaana", coupons: 8 },
  { name: "JioSaavn", coupons: 14},
  { name: "BookMyShow", coupons: 11 },
  { name: "Paytm", coupons: 10 },
  { name: "Google Pay", coupons: 9 },
  { name: "PhonePe", coupons: 5 },
  { name: "Home Centre", coupons: 7 },
  { name: "Wakefit", coupons: 2 },
  { name: "Godrej Interio", coupons: 4},
  { name: "Prestige", coupons: 5 },
  { name: "Hawkins", coupons: 2},
  { name: "Pigeon", coupons: 6 },
  { name: "H&M", coupons: 7 },
  { name: "Zara", coupons: 5 },
  { name: "Marks & Spencer", coupons: 6 },
  { name: "Lifestyle Stores", coupons: 14 },
  { name: "Allen Solly", coupons: 4 },
  { name: "Peter England", coupons: 13 },
  { name: "Louis Philippe", coupons: 9 },
  { name: "Arrow", coupons: 3 },
  { name: "Jack & Jones", coupons: 7 },
  { name: "Vero Moda", coupons: 3 },
  { name: "Only", coupons:4 },
  { name: "United Colors of Benetton", coupons: 7 },
  { name: "Tommy Hilfiger", coupons: 4 },
  { name: "Calvin Klein", coupons: 5},
  { name: "Levi's", coupons: 6 },
  { name: "Wrangler", coupons: 7 },
  { name: "Lee Cooper", coupons: 5 },
  { name: "Biba", coupons: 8},
  { name: "W for Woman", coupons: 5},
  { name: "Fabindia", coupons: 4 },
  { name: "BigRock", coupons:5 },
  { name: "Hostinger", coupons: 11},
  { name: "GoDaddy", coupons: 18 }
];

// ✅ Slugify helper to make clean URLs
const makeSlug = (name) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")   // replace spaces & special chars with -
    .replace(/(^-|-$)/g, "");      // trim leading/trailing -

export default function Store() {
  const getStoreLink = (name) => `/store/${makeSlug(name)}`;

  // Function to get today's date minus 2 days in DD/MM/YYYY format
const getVerifiedDate = () => {
  const today = new Date();
  const verifiedDate = new Date(today);
  verifiedDate.setDate(today.getDate() - 2);

  const day = String(verifiedDate.getDate()).padStart(2, "0");
  const month = String(verifiedDate.getMonth() + 1).padStart(2, "0");
  const year = verifiedDate.getFullYear();

  return `${day}/${month}/${year}`;
};

  return (
    <div className="store-container">
      {/* Header Section */}
      <header className="store-header">
        <div className="merchant-summary">
          <h2 className="summary-title">ALL MERCHANTS</h2>
          <div className="summary-details">
            <p>Total Merchants: 100+</p>
            <p>Total Coupons & Offers: 1000+</p>
<p className="verified">✔ Verified On: {getVerifiedDate()}</p>
          </div>
        </div>
        <div className="header-text">
          <h1>All Merchants</h1>
          <p>
            Who doesn’t love a great deal? GrabOn brings you the best discounts
            from top stores like Amazon, Flipkart, Myntra, Nykaa, Swiggy, Domino’s
            and more...
          </p>
        </div>
      </header>

      {/* Trending Merchants */}
      <section className="trending-merchants">
        <h2 className="section-title">Trending Merchants</h2>
        <div className="trending-list">
          {trendingMerchants.map((m, idx) => (
            <a
              key={idx}
              href={getStoreLink(m.name)}
              className="merchant-card"
            >
              <img src={m.logo} alt={m.name} className="merchant-logo" />
              <h3 className="merchant-name">{m.name}</h3>
              <p className="merchant-stats">
                {m.coupons} Coupons
              </p>
            </a>
          ))}
        </div>
      </section>

      {/* All Merchants List */}
      <section className="all-merchants">
        <h2 className="section-title">Browse All Merchants</h2>
        <div className="all-merchants-list">
          {allMerchants.map((m, idx) => (
            <Link
              key={idx}
              to={getStoreLink(m.name)}
              className="merchant-item"
            >
              <p className="merchant-name">{m.name}</p>
              <p className="merchant-stats">
                {m.coupons} Coupons
              </p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}